import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { insertVendorController, vendorListController } from "../../services/vendorServices/vendorServices";
import { toast } from "react-toastify";
import ModalBox from "../../common/ModalBox";
import {
  addProductController,
} from "../../services/productServices/productListingController";
import useButtonLoader from "../../hooks/useButtonLoader";
import Select from "react-select";

function AddProduct() {
  const [allDisable, setAllDisable] = useState(false);
  const [isSkuDisabled, setIsSkuDisabled] = useState(false); 
  const [showModal, setShowModal] = useState(false);
  const [zohoProductData, setZohoProductData] = useState(null);
  const [multipleproductImage, setMultipleProductImage] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [inputFieldValue, setInputFieldValue] = useState({});
  const [errors, setErrors] = useState({});
  const [productId, setProductId] = useState(null);
  const [submitButton, setSubmitButton] = useButtonLoader(
    "Add",
    "Please wait..."
  );
  const navigate = useNavigate();
  const uploadProductImage = useRef();
  const [vendors, setVendors] = useState([]);
  const [inputValue, setInputValue] = useState("");


  const handleCloseModal = () => setShowModal(false);
    // Load vendors from props when the component mounts or vendorList changes
    useEffect(() => {
      setVendors(vendorList.map(({ id, name }) => ({ value: id, label: name })));
    }, [vendorList]);
  
    // Handle search input changes
    const handleInputChange = (value) => {
      setInputValue(value);
    };
  
    // Handle selection change
    const handleChange = async (selectedOption) => {
      if (selectedOption?.value === "add_new") {
        if (!inputValue) return;  
        try {

          const formData = new FormData();
          formData.append("name", inputValue);
          setSubmitButton(true);
          const response = await insertVendorController(formData);
          if (response.code === 200) {
            toast.success(response?.message);
          }
          if (response?.data?.data && response?.data?.data?.id) {
            const newVendor = { value:response?.data?.data?.id, label: response?.data?.data?.name };
            setVendors((prevVendors) => [...prevVendors, newVendor]);
            inputFieldHandler({ target: { name: "vendorId", value: newVendor.value } });
          }
          else{
            toast.error(response?.message);
            setSubmitButton(false);
          }
        } catch (error) {
          console.error("Error adding vendor:", error);
          setSubmitButton(false);
        } 
        finally{
          setSubmitButton(false);
        }
      } else {
        inputFieldHandler({ target: { name: "vendorId", value: selectedOption?.value || "" } });
      }
    };
  
    // Add "Add New" option if input value is not found in the vendor list
    const options = [
      ...vendors,
      ...(inputValue.length >= 3  &&
      !vendors.some((vendor) => vendor.label.toLowerCase() === inputValue.toLowerCase())
        ? [{ value: "add_new", label: `Add New: "${inputValue}"` }]
        : []),
    ];

  const zohoDataForm = () => {
    if (zohoProductData) {
      setInputFieldValue({
        ...inputFieldValue,
        name: zohoProductData.name || "",
        units: zohoProductData.unit || "",
        noOfStock: zohoProductData.actual_available_for_sale_stock?.toString() || "",
        margin: zohoProductData.cf_margin_unformatted?.toString() || "",
        productComposition: zohoProductData.description || "",
        mrp: zohoProductData.cf_mrp,
        netPrice: zohoProductData.rate?.toString() || "",
        dimension: zohoProductData.cf_packaging,
        manufacturer: zohoProductData.manufacturer || "",
        sku: zohoProductData.sku || "",
      });
      setIsSkuDisabled(true);
      setAllDisable(false);
      setShowModal(false);
    }
  };

  const handleView = () => {
    navigate(`/product-management/view/${productId}`);
  };

  const handleEdit = () => {
    navigate(`/product-management/edit/${productId}`);
  };

  // Function for checking alphanumeric
  function containsAlphaNumeric(input) {
    // Check if the input contains at least one alphabetic character and one numeric character
    return /[a-zA-Z]/.test(input) && /[0-9]/.test(input);
  }

    // Margin calculation
    const calculatedMargin =
    inputFieldValue?.mrp && inputFieldValue?.netPrice
      ? parseFloat(inputFieldValue?.mrp) - parseFloat(inputFieldValue?.netPrice)
      : "";

  // Input Field Validation
  const inputFieldValidation = () => {
    let error = {};
    const validImageFormat = ["image/jpg", "image/jpeg", "image/png"];
    let validationStatus = true;
    console.log("inputFieldValue.gstPercentage",inputFieldValue.gstPercentage)
    if (!inputFieldValue.gstPercentage) {
      error["gstPercentage"] = "Required*";
      validationStatus = false;
    }
    if (!inputFieldValue.compositionName) {
      error["compositionName"] = "Required*";
      validationStatus = false;
    }
    if (!inputFieldValue.vendorId) {
      error["vendorId"] = "Required*";
      validationStatus = false;
    }
    if (!inputFieldValue.netPrice) {
      error["netPrice"] = "Required*";
      validationStatus = false;
    }
    if (!inputFieldValue.productName) {
      error["productName"] = "Required*";
      validationStatus = false;
    }
    if (!inputFieldValue.noOfStock) {
      error["noOfStock"] = "Required*";
      validationStatus = false;
    }
    if (multipleproductImage.length === 0) {
      error["productImage"] = "Required*";
      validationStatus = false;
    }
    if (!inputFieldValue.sku) {
      error["sku"] = "Required*";
      validationStatus = false;
    }
    if (!inputFieldValue.noOfUnitPerPack) {
      error["noOfUnitPerPack"] = "Required*";
      validationStatus = false;
    }
    if (inputFieldValue.sku && !containsAlphaNumeric(inputFieldValue.sku)) {
      error["sku"] = "SKU should contain both Alphabet & Numerical*";
      validationStatus = false;
    }
    if (multipleproductImage.length > 0) {
      multipleproductImage.forEach((image, index) => {
        if (!validImageFormat.includes(image.type)) {
          error["productImage"] = `Invalid image format at ${index + 1}`;
          validationStatus = false;
        }
      });
    }
    if (!inputFieldValue.margin) {
      error["margin"] = "Required*";
      validationStatus = false;
    }
    if (inputFieldValue.margin<0) {
       error["margin"] = "Margin can't be negative*";
      validationStatus = false;
    }
    if (!inputFieldValue.mrp) {
      error["mrp"] = "Required*";
      validationStatus = false;
    }

    if (!inputFieldValue.dimestion) {
      error["dimestion"] = "Required*";
      validationStatus = false;
    }
    if (!inputFieldValue.smallestUnit) {
      error["smallestUnit"] = "Required*";
      validationStatus = false;
    }
    setErrors(error);
    return validationStatus;
  };

  //Fetching Vendor List
  const fetchingVendorList = async () => {
    const response = await vendorListController();
    console.log(response);
    if (response?.code === 200) {
      setVendorList(response?.data?.rows);
    } else {
      toast.error(response?.message);
    }
  };

  // multiple image handler function
 const multipeImageHandler = (e) => {
  const imageFormat = ["image/jpg", "image/jpeg", "image/png"];
  const { files } = e.target;
  const maxSize = 1024 * 1024; // 1MB

  if (files.length > 0) {
    let validFiles = true;

    for (let i = 0; i < files.length; i++) {
      if (files[i].size > maxSize) {
        toast.error("Image size should not be larger than 1MB");
        validFiles = false;
        break;
      }
      if (!imageFormat.includes(files[i].type)) {
        toast.error("Invalid image format");
        validFiles = false;
        break;
      }
    }

    if (validFiles) {
      if (files.length + multipleproductImage.length <= 10) {
        setMultipleProductImage([...multipleproductImage, ...files]);
      } else {
        toast.error("Sorry, you can't upload more than 10 images");
      }
    }
  }
};


  // const inputFieldHandler = (e, type = "") => {
  //   let { name, value } = e.target;
  //   const valueType = typeof value;
  //   console.log("valueType", valueType);
  //   console.log("name",name)

  //   if (type === "number" && valueType === "string") {
  //     let updatedValue = value.replace(/[^0-9.]/g, ""); // Remove non-numeric and non-dot characters
  //     updatedValue = updatedValue.replace(/(\.\d{2})\d*$/, "$1"); // Restrict to 2 decimal places
  //     setInputFieldValue({ ...inputFieldValue, [name]: updatedValue });
  //   } else if (type === "text" && valueType === "string") {
  //     let updatedValue = value.replace(/[^a-zA-Z]/g, ""); // Allow only alphabets
  //     setInputFieldValue({ ...inputFieldValue, [name]: updatedValue });
  //   } else if (type === "dimension" && valueType === "string") {
  //     let updatedValue = value.replace(/[^0-9xX*]/g, ""); // Allow digits and 'x' or 'X'
  //     setInputFieldValue({ ...inputFieldValue, [name]: updatedValue });
  //   } else if (type === "noOfProduct" && valueType === "string") {
  //     let updatedValue = value.replace(/^[^1-9]|[^0-9*]/g, "");
  //     setInputFieldValue({ ...inputFieldValue, [name]: updatedValue });
  //   } else if (type === "sku" && valueType === "string") {
  //     let updatedValue = value.replace(/[^a-zA-Z0-9_ -]/g, ""); // Allow alphanumeric characters, underscores, hyphens, and spaces
  //     setInputFieldValue({ ...inputFieldValue, [name]: updatedValue });
  //   }
  //    else {
  //     setInputFieldValue({ ...inputFieldValue, [name]: value });
  //   }
  //    if (inputFieldValue?.mrp && inputFieldValue?.netPrice) {
  //      const calculatedMargin =
  //        inputFieldValue?.mrp && inputFieldValue?.netPrice
  //          ? parseFloat(inputFieldValue?.mrp) -
  //            parseFloat(inputFieldValue?.netPrice)
  //          : "";
  //      if (calculatedMargin) {
  //        name = "margin";
  //        setInputFieldValue({
  //          ...inputFieldValue,
  //          [name]: calculatedMargin,
  //        });
  //      }

  //      console.log("calculatedMargin", calculatedMargin);
  //    }
  // };

  const inputFieldHandler = (e, type = "") => {
  let { name, value } = e.target;
  const valueType = typeof value;
  let updatedValue = value;

  if (type === "number" && valueType === "string") {
    updatedValue = value.replace(/[^0-9.]/g, ""); // Remove non-numeric and non-dot characters
    updatedValue = updatedValue.replace(/(\.\d{2})\d*$/, "$1"); // Restrict to 2 decimal places
  } else if (type === "text" && valueType === "string") {
    updatedValue = value.replace(/[^a-zA-Z]/g, ""); // Allow only alphabets
  } else if (type === "dimension" && valueType === "string") {
    updatedValue = value.replace(/[^0-9xX*]/g, ""); // Allow digits and 'x' or 'X'
  } else if (type === "noOfProduct" && valueType === "string") {
    updatedValue = value.replace(/^[^1-9]|[^0-9*]/g, "");
  } else if (type === "sku" && valueType === "string") {
    updatedValue = value.replace(/[^a-zA-Z0-9_ -]/g, ""); // Allow alphanumeric, underscores, hyphens, and spaces
  }

  // Prepare new state
  const newFieldValue = { ...inputFieldValue, [name]: updatedValue };

  // Calculate margin if mrp and netPrice are present
  if (newFieldValue?.mrp && newFieldValue?.netPrice) {
    const calculatedMargin =
      parseFloat(newFieldValue.mrp) - parseFloat(newFieldValue.netPrice);

    newFieldValue.margin = calculatedMargin;
  }

  // Set updated state
  setInputFieldValue(newFieldValue);
};

  const removeProductImage = (id) => {
    const newProductImage = [...multipleproductImage];
    newProductImage.splice(id, 1);
    setMultipleProductImage(newProductImage);
  };

  // Add Product
  const addProductHandler = async (e) => {
    e.preventDefault();
    const status = inputFieldValidation();
    if (status) {
      try {
        setSubmitButton(true);
        const formData = new FormData();
        const adminRole = localStorage.getItem("role");
        console.log(inputFieldValue, "inputFieldValue");
        formData.append("productName", inputFieldValue.productName || "");
        formData.append("vendorId", inputFieldValue.vendorId || "");
        formData.append("role", adminRole || "");
        formData.append(
          "compositionName",
          inputFieldValue.compositionName || ""
        );
        formData.append("units", inputFieldValue.units || "");
        formData.append("noOfStock", inputFieldValue.noOfStock || "");
        formData.append(
          "noOfUnitPerPack",
          inputFieldValue?.noOfUnitPerPack || ""
        );
        formData.append("margin", inputFieldValue.margin || "");
        formData.append(
          "marginPerUnit",
          inputFieldValue.margin && inputFieldValue.noOfUnitPerPack
            ? formatValue(
                inputFieldValue.margin / inputFieldValue.noOfUnitPerPack
              )
            : ""
        );
        formData.append(
          "productComposition",
          inputFieldValue.productComposition || ""
        );
        formData.append("mrp", inputFieldValue.mrp || "");
        formData.append("smallestUnit", inputFieldValue.smallestUnit || "");
        formData.append(
          "mrpPerUnit",
          inputFieldValue.mrp && inputFieldValue.noOfUnitPerPack
            ? formatValue(inputFieldValue.mrp / inputFieldValue.noOfUnitPerPack)
            : ""
        );
        formData.append("netPrice", inputFieldValue.netPrice || "");
        formData.append(
          "netPricePerUnit",
          inputFieldValue.netPrice && inputFieldValue.noOfUnitPerPack
            ? formatValue(
                inputFieldValue.netPrice / inputFieldValue.noOfUnitPerPack
              )
            : ""
        );
        formData.append("dimestion", inputFieldValue.dimestion || "");

        formData.append("sku", inputFieldValue.sku || "");
        formData.append("gstPercentage", inputFieldValue.gstPercentage || "");

        multipleproductImage.forEach((item, index) => {
          formData.append("productImage", item);
        });

        const response = await addProductController(formData);
        if (response.code === 200) {
          toast.success(response?.message);
          setSubmitButton(false);
          navigate(-1);
        } else {
          toast.error(response?.message);
          setSubmitButton(false);
        }
      } catch (e) {
        console.log(e.message);
        setSubmitButton(false);
      }
    }
  };

  // For Format Decimal Value
  const formatValue = (value) => {
    let formattedValue = "";
    const floatValue = parseFloat(value);
    const roundedValue = floatValue.toFixed(2);
    formattedValue = roundedValue;
    return formattedValue;
  };
  const handleBlur = () => {
    if (inputFieldValue.sku && inputFieldValue.sku.trim() !== "") {
      setAllDisable(false);
    } else {
      setAllDisable(true);
    }
  };

  useEffect(() => {
    fetchingVendorList();
  }, []);

  return (
    <React.Fragment>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <h2 className="page-title">
              <span
                className="page-title-icon bg-gradient-primary text-white me-2"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <i className="mdi mdi-chevron-double-left"></i>
              </span>
              Add Products
            </h2>
            <nav aria-label="breadcrumb"></nav>
          </div>
          <div className="wrap_Add_retailer">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <form className="form-sample">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Product Name <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              className="form-control"
                              maxLength={45}
                              name="productName"
                              placeholder="Enter Product Name"
                              value={inputFieldValue.name}
                              onChange={inputFieldHandler}
                              disabled={allDisable}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.productName}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">
                            Marketed By <span className="text-danger">*</span>
                          </label>
                          <div class="col-sm-9 text-start">
                            <Select
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: "#ebedf2",
                                }),
                                placeholder: (provided, state) => ({
                                  ...provided,
                                  fontSize: "13px",
                                  color:"#C9C8C8",
                                }),
                                menuList: (provided, state) => ({
                                  ...provided,
                                  fontSize: "13px",
                                }),
                                valueContainer: (provided, state) => ({
                                  ...provided,
                                  fontSize: "13px",
                                }),

                              }}
                              options={options}
                              value={
                                options.find(
                                  (option) =>
                                    option.value === inputFieldValue.vendorId
                                ) || null
                              }
                              onInputChange={handleInputChange}
                              onChange={handleChange}
                              placeholder="Select or add a marketer"
                              isSearchable
                              isClearable
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.vendorId}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Composition Name <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              maxLength={60}
                              className="form-control"
                              name="compositionName"
                              placeholder="Enter Composition Name"
                              value={inputFieldValue.compositionName}
                              onChange={inputFieldHandler}
                              disabled={allDisable}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.compositionName}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            SKU <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <div className="input-group">
                              <input
                                type="text"
                                maxLength={50}
                                className="form-control"
                                name="sku"
                                placeholder="Enter SKU (e.g: ABC_123)"
                                value={inputFieldValue.sku}
                                disabled={isSkuDisabled}
                                onChange={(e) => {
                                  inputFieldHandler(e, "sku");
                                }}
                                onBlur={handleBlur}
                              />
                           
                            </div>
                            <span style={{ color: "red" }} className="error">
                              {errors.sku}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Units
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              className="form-control"
                              name="units"
                              maxLength={15}
                              placeholder="Enter Units in Kilogram, litre"
                              value={inputFieldValue.units}
                              onChange={(e) => {
                                inputFieldHandler(e, "text");
                              }}
                              disabled={allDisable}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Smallest Unit <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              maxLength={15}
                              className="form-control"
                              name="smallestUnit"
                              placeholder="Enter unit in kg , ltr"
                              value={inputFieldValue.smallestUnit}
                              onChange={(e) => {
                                inputFieldHandler(e, "text");
                              }}
                              disabled={allDisable}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.smallestUnit}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Packaging <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              maxLength={11}
                              className="form-control"
                              name="dimestion"
                              placeholder="NNNxNNNxNNN"
                              value={inputFieldValue.dimestion}
                              onChange={(e) => {
                                inputFieldHandler(e, "dimension");
                              }}
                              disabled={allDisable}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.dimestion}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            No. of Stock <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              name="noOfStock"
                              type="text"
                              maxLength={8}
                              className="form-control"
                              placeholder="Enter No. Of Stocks"
                              value={inputFieldValue.noOfStock}
                              onChange={(e) => {
                                inputFieldHandler(e, "noOfProduct");
                              }}
                              // disabled={true}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.noOfStock}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*  */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            MRP <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              className="form-control"
                              maxLength={8}
                              name="mrp"
                              placeholder="Enter MRP"
                              value={inputFieldValue.mrp}
                              onChange={(e) => {
                                inputFieldHandler(e, "number");
                              }}
                              disabled={allDisable}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.mrp}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            MRP Per Unit
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              disabled={allDisable}
                              className="form-control"
                              placeholder="Enter MRP/Unit"
                              name="mrpPerUnit"
                              value={
                                inputFieldValue.mrp &&
                                inputFieldValue.noOfUnitPerPack
                                  ? formatValue(
                                      inputFieldValue.mrp /
                                        inputFieldValue.noOfUnitPerPack
                                    )
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Net Price <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              maxLength={8}
                              className="form-control"
                              placeholder="Enter Net Price"
                              name="netPrice"
                              value={inputFieldValue.netPrice}
                              onChange={(e) => {
                                inputFieldHandler(e, "number");
                              }}
                              disabled={allDisable}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.netPrice}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Net Price Per Unit
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              disabled={allDisable}
                              className="form-control"
                              name="netPricePerUnit"
                              placeholder="Enter Net Price/Unit"
                              value={
                                inputFieldValue.netPrice &&
                                inputFieldValue.noOfUnitPerPack
                                  ? formatValue(
                                      inputFieldValue.netPrice /
                                        inputFieldValue.noOfUnitPerPack
                                    )
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Margin <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              disabled={true}
                              type="text"
                              maxLength={8}
                              className="form-control"
                              placeholder="Enter Margin"
                              name="margin"
                              value={calculatedMargin}
                              onChange={(e) => {
                                inputFieldHandler(e, "number");
                              }}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.margin}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Margin Per Unit
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="text"
                              disabled={allDisable}
                              className="form-control"
                              name="marginPerUnit"
                              placeholder="Enter Margin/Unit"
                              value={
                                inputFieldValue.margin &&
                                inputFieldValue.noOfUnitPerPack
                                  ? formatValue(
                                      inputFieldValue.margin /
                                        inputFieldValue.noOfUnitPerPack
                                    )
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            No. of units per pack{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              disabled={allDisable}
                              name="noOfUnitPerPack"
                              type="text"
                              maxLength={8}
                              className="form-control"
                              placeholder="Enter No. Of Units"
                              value={inputFieldValue.noOfUnitPerPack}
                              onChange={(e) => {
                                inputFieldHandler(e, "noOfProduct");
                              }}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.noOfUnitPerPack}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            GST <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9 text-start">
                            <input
                              type="number"
                              maxLength={5}
                              className="form-control"
                              name="gstPercentage"
                              placeholder="Enter GST (12)"
                              onChange={(e) => {
                                inputFieldHandler(e, "gstPercentage");
                              }}
                              value={inputFieldValue.gstPercentage}
                            />
                            <span style={{ color: "red" }} className="error">
                              {errors.gstPercentage}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group row">
                          <label className="col-sm-2 col-form-label cstm_width">
                            Product Description
                          </label>
                          <div className="col-sm-10 text-start cstm_width2">
                            <textarea
                              disabled={allDisable}
                              type="text"
                              className="form-control"
                              name="productComposition"
                              placeholder="Enter Product Description Here..."
                              rows="4"
                              onChange={inputFieldHandler}
                              value={inputFieldValue.productComposition}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row cstm_position_set">
                      <div className="col-sm-12">
                        <div className="form-group cstm_wrap_position">
                          <label>
                            Product Image <span className="text-danger">*</span>
                          </label>

                          <div className="col-sm-9 text-end">
                            <input
                              disabled={allDisable}
                              ref={uploadProductImage}
                              type="file"
                              multiple
                              name="productImage"
                              accept="image/*"
                              className="form-control file-upload-info"
                              hidden
                              placeholder="Upload Image"
                              onChange={multipeImageHandler}
                            />
                            <span
                              style={{ color: "red" }}
                              className="error cstm_ere"
                            >
                              {errors.productImage}
                            </span>
                            <span className="input-group-append cstm_append_group">
                              <button
                                disabled={allDisable}
                                className="file-upload-browse btn btn-gradient-primary"
                                type="button"
                                onClick={() =>
                                  uploadProductImage.current?.click()
                                }
                              >
                                Upload
                              </button>
                            </span>
                          </div>
                        </div>
                        <div className="mb-4 mt-4">
                          <div className="row">
                            {multipleproductImage.length > 0 &&
                              multipleproductImage.map((image, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <div className="col-3 cstm_upload_image">
                                      <span className="cstm_close_icon">
                                        <i
                                          className="mdi mdi-close-circle-outline"
                                          onClick={() =>
                                            removeProductImage(index)
                                          }
                                        ></i>
                                      </span>
                                      <img
                                        src={URL.createObjectURL(image)}
                                        className="mb-2 mw-100 w-100 rounded"
                                        alt="banner"
                                        height="150px"
                                        width="200px"
                                      />
                                    </div>
                                  </React.Fragment>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      disabled={allDisable}
                      type="submit"
                      ref={submitButton}
                      className="btn btn-gradient-primary mb-2"
                      onClick={(e) => addProductHandler(e)}
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalBox
          status={showModal}
          onClose={handleCloseModal}
          title={zohoProductData ? "Product Found in Zoho" : "Product Found"}
          description={
            zohoProductData
              ? "The product is available in Zoho. Click the button below to add the details in Stoklo."
              : "The product exists in the Stoklo. What would you like to do?"
          }
          customizedFooter={
            zohoProductData ? (
              <>
              <button className="btn btn-gradient-dark" onClick={zohoDataForm}>
                  Save the Product in Stoklo
                </button>
                <button
                  className="btn btn-gradient-light"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </>
            ) : (
              <>
                <button className="btn btn-gradient-dark" onClick={handleView}>
                  View
                </button>
                <button
                  className="btn btn-gradient-warning"
                  onClick={handleEdit}
                >
                  Edit
                </button>
              </>
            )
          }
        />
      </div>
    </React.Fragment>
  );
}

export default AddProduct;
